module.exports = __webpack_public_path__ + "img/processor.7834476b.png";